import React from "react";

export const InlineListItem = props =>
  <li className="list-inline-item">
    {props.children}
  </li>;